// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import $ from 'jquery'
import Vi from './components/Vi'
import Mitation from './components/Mitation'
import Colored from './components/Colored'
import Download from './components/Download'
import Rap from './components/Rap'
import Query from './components/Query'
import Login from './components/Login'
import LoginPassword from './components/LoginPassword'
import WechatLogin from './components/WechatLogin'
import Reg from './components/Reg'
import Home from './components/Home'
import Headers from './components/Headers'
import Footers from './components/Footers'
import Cart from './components/Cart'
import Hold from './components/Hold'
import Order from './components/Order'
import OrderDetail from './components/OrderDetail'
import Contact from './components/Contact'
import Search from './components/Search'
//import './assets/index.css';
import './assets/style.css';
import './assets/page.css';

import "./assets/jquery.min.js";
import "./assets/bootstrap-3.3.7-dist/js/bootstrap.min.js";
import "./assets/bootstrap-3.3.7-dist/css/bootstrap.min.css";


Vue.use(VueRouter)
Vue.use(VueResource)

Vue.config.productionTip = false

//全局组件注册
//Vue.component("users",Users);
Vue.component("Headers",Headers);
Vue.component("Footers",Footers);

/* eslint-disable no-new */
const router = new VueRouter({
   routes:[
	{path:'/',component:Home},
	{path:'/vi',component:Vi},
	{path:'/mitation',component:Mitation},
	{path:'/colored',component:Colored},
	{path:'/download',component:Download},
	{path:'/contact',component:Contact},
	{path:'/search',component:Search},
	{path:'/price',component:Rap},
	{path:'/query',component:Query},
	{path:'/login',component:Login},
	{path:'/loginpassword',component:LoginPassword},
	{path:'/wechatlogin',component:WechatLogin},
	{path:'/reg',component:Reg},
	{path:'/cart',component:Cart},
	{path:'/hold',component:Hold},
	 {path:'/order',component:Order},
	   {
		 path: '/order/:id',
		 component: OrderDetail
       }
   ],
   mode:'history'
})


new Vue({
  router,
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js